export var StaffRolePermission;
(function (StaffRolePermission) {
    StaffRolePermission["UserSelectable"] = "userSelectable";
    StaffRolePermission["AllowSelfRegistration"] = "allowSelfRegistration";
    StaffRolePermission["AllowJoinTeam"] = "allowJoinTeam";
    StaffRolePermission["AllowInviteStaff"] = "allowInviteStaff";
    StaffRolePermission["AllowInviteThisRole"] = "allowInviteThisRole";
    StaffRolePermission["AllowInvitePlayers"] = "allowInvitePlayers";
    StaffRolePermission["AllowManagedStaffManagedFields"] = "allowManagedStaffManagedFields";
    StaffRolePermission["AllowSubmitRoster"] = "allowSubmitRoster";
    StaffRolePermission["AllowCheckin"] = "allowCheckin";
    StaffRolePermission["AllowAddEditScores"] = "allowAddEditScores";
})(StaffRolePermission || (StaffRolePermission = {}));
